import { Component, OnInit } from '@angular/core';
import { WhosWhoService } from '../../websiteCMS/pages/whos-who/whos-who.service';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  visitorCount: string = '';
  dataSource!: string;
  constructor(
    private whosWhoservice: WhosWhoService,
    private router: Router,
  ) {}
  get isEnquiryPage(): boolean {
    return this.router.url === '/enquiry';
  }

  ngOnInit() {
    this.getVisitorCount();
    this.getUpdatedDate();
  }

  getVisitorCount() {
    // this.visitorCount = '10';
    this.whosWhoservice.getVistorcountDate().subscribe(
      (response) => {
        // console.log('API Response:', response); // Debugging step
        if (response && response.totalUniqueVisitors) {
          this.visitorCount = response.totalUniqueVisitors; // Correct property access
          console.log('visitorCount:', this.visitorCount);
        } else {
          console.warn('Response does not contain lastUpdatedAt');
        }
      },
      (error) => {
        console.error('Error fetching updated date:', error);
      },
    );
  }
  getUpdatedDate() {
    this.whosWhoservice.getUpdatedDate().subscribe(
      (response) => {
        // console.log('API Response:', response); // Debugging step
        if (response && response.lastUpdatedAt) {
          this.dataSource = response.lastUpdatedAt; // Correct property access
          // console.log('UpdateDate:', this.dataSource);
        } else {
          console.warn('Response does not contain lastUpdatedAt');
        }
      },
      (error) => {
        console.error('Error fetching updated date:', error);
      },
    );
  }

  isHighlighted = false;

  highlightSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      this.isHighlighted = true;

      // Scroll into view (optional)
      // section.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Remove highlight after 3 seconds
      setTimeout(() => {
        this.isHighlighted = false;
      }, 5000);
    }
  }
}
